import { oz } from '@weft/utils';

export const passwordConfirmationSchema = oz.string().min(1, 'Confirmation password is required').openapi('PasswordConfirmationSchema');

export type PasswordConfirmation = oz.infer<typeof passwordConfirmationSchema>;